module.exports = __webpack_public_path__ + "img/dolchspace.aa8378fa.png";